import { atom } from "recoil"

export const isInitializingState = atom<boolean>({
  key: "initializingState",
  default: false,
})

export const isInitializingFinishedState = atom<boolean>({
  key: "isInitializingFinishedState",
  default: false,
})
